import { useParams, Link } from 'react-router-dom';
import { useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import { videos } from '@/mocks/videos';

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const videoId = Number(id);

  const video = useMemo(() => videos.find((v) => v.id === videoId), [videoId]);

  const relatedVideos = useMemo(() => {
    if (!video) return [];
    return videos
      .filter((v) => v.id !== video.id && v.category === video.category)
      .slice(0, 6);
  }, [video]);

  const posterUrls: Record<number, string> = {
    1: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20poster%20for%20Chinese%20sci-fi%20film%20The%20Wandering%20Earth%203%20with%20massive%20space%20station%20and%20Earth%20dramatic%20lighting%20warm%20orange%20and%20deep%20black%20tones%20professional%20movie%20key%20art&width=800&height=450&seq=article-poster-01&orientation=landscape',
    2: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20poster%20for%20Chinese%20animated%20film%20Chang%20An%20with%20Tang%20dynasty%20poets%20and%20warriors%20golden%20sunlight%20traditional%20painting%20style%20warm%20golden%20and%20crimson%20tones&width=800&height=450&seq=article-poster-02&orientation=landscape',
    3: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20film%20poster%20Creation%20of%20the%20Gods%20with%20ancient%20warriors%20and%20mythical%20creatures%20dramatic%20battle%20smoke%20fire%20bronze%20crimson%20color%20palette&width=800&height=450&seq=article-poster-03&orientation=landscape',
    4: 'https://readdy.ai/api/search-image?query=Cinematic%20racing%20movie%20poster%20Pegasus%203%20with%20sports%20car%20on%20desert%20highway%20sunset%20dust%20trails%20warm%20golden%20light%20action%20speed&width=800&height=450&seq=article-poster-04&orientation=landscape',
    5: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20film%20poster%20Full%20River%20Red%202%20Song%20dynasty%20courtyard%20dark%20atmospheric%20lighting%20traditional%20architecture%20deep%20red%20black%20suspenseful&width=800&height=450&seq=article-poster-05&orientation=landscape',
    6: 'https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20Boonie%20Bears%20futuristic%20with%20bears%20in%20cyberpunk%20city%20neon%20lights%20robots%20colorful%20playful%20family%20animation&width=800&height=450&seq=article-poster-06&orientation=landscape',
    7: 'https://readdy.ai/api/search-image?query=Gritty%20Chinese%20crime%20drama%20TV%20series%20poster%20The%20Knockout%20with%20police%20and%20gangster%20face%20to%20face%20dark%20urban%20rainy%20night%20high%20contrast%20neo-noir&width=800&height=450&seq=article-poster-07&orientation=landscape',
    8: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20court%20drama%20TV%20poster%20Joy%20of%20Life%20Season%202%20elegant%20man%20traditional%20robes%20imperial%20palace%20golden%20deep%20red%20power%20intrigue&width=800&height=450&seq=article-poster-08&orientation=landscape',
    9: 'https://readdy.ai/api/search-image?query=Science%20fiction%20TV%20series%20poster%20Three%20Body%20with%20mysterious%20alien%20signal%20scientists%20cosmic%20background%20green%20black%20tones%20mind-bending&width=800&height=450&seq=article-poster-09&orientation=landscape',
    10: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20TV%20drama%20poster%20Lost%20You%20Forever%20beautiful%20woman%20flowing%20dress%20ethereal%20lighting%20peach%20blossoms%20soft%20pastel&width=800&height=450&seq=article-poster-10&orientation=landscape',
    11: 'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20TV%20drama%20poster%20The%20Tale%20of%20Rose%20elegant%20woman%20city%20skyline%20warm%20evening%20light%20sophisticated%20rose%20gold%20cream%20tones&width=800&height=450&seq=article-poster-11&orientation=landscape',
    12: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20comedy%20TV%20drama%20poster%20Guardians%20of%20the%20Dafeng%20handsome%20warrior%20fighting%20demons%20ancient%20setting%20dynamic%20action%20golden%20vermilion&width=800&height=450&seq=article-poster-12&orientation=landscape',
    13: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20Keep%20Running%20Ecology%20with%20celebrity%20cast%20running%20laughing%20outdoors%20bright%20sunny%20green%20nature%20energetic%20fun&width=800&height=450&seq=article-poster-13&orientation=landscape',
    14: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20Singer%202026%20with%20singers%20on%20stage%20dramatic%20spotlights%20concert%20atmosphere%20dark%20background%20golden%20stage%20lights%20grand&width=800&height=450&seq=article-poster-14&orientation=landscape',
    15: 'https://readdy.ai/api/search-image?query=Peaceful%20Chinese%20countryside%20variety%20show%20poster%20Back%20to%20Field%20seaside%20village%20wooden%20house%20warm%20sunset%20cooking%20outdoors%20cozy%20healing%20earthy&width=800&height=450&seq=article-poster-15&orientation=landscape',
    16: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20sketch%20show%20poster%20Super%20Sketch%20Show%20with%20comedians%20theater%20bright%20stage%20lights%20colorful%20costumes%20humorous%20red%20curtains%20festive&width=800&height=450&seq=article-poster-16&orientation=landscape',
  };

  const relatedImageUrls: Record<number, string> = {
    1: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Chinese%20sci-fi%20movie%20Wandering%20Earth%203%20cinematic%20warm%20tones%20compact%20format&width=224&height=128&seq=related-thumb-01&orientation=landscape',
    2: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Chinese%20animated%20movie%20Chang%20An%20Tang%20dynasty%20poets%20golden%20warm%20tones%20compact&width=224&height=128&seq=related-thumb-02&orientation=landscape',
    3: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Chinese%20fantasy%20epic%20Creation%20Gods%20ancient%20warriors%20battle%20warm%20crimson%20compact&width=224&height=128&seq=related-thumb-03&orientation=landscape',
    4: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20racing%20comedy%20Pegasus%203%20car%20desert%20sunset%20warm%20golden%20compact&width=224&height=128&seq=related-thumb-04&orientation=landscape',
    5: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20historical%20mystery%20Full%20River%20Red%202%20ancient%20courtyard%20dark%20suspenseful%20compact&width=224&height=128&seq=related-thumb-05&orientation=landscape',
    6: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Boonie%20Bears%20animation%20futuristic%20cyberpunk%20colorful%20playful%20compact&width=224&height=128&seq=related-thumb-06&orientation=landscape',
    7: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Chinese%20crime%20drama%20The%20Knockout%20dark%20neo-noir%20compact&width=224&height=128&seq=related-thumb-07&orientation=landscape',
    8: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Joy%20of%20Life%20Season%202%20imperial%20palace%20golden%20red%20compact&width=224&height=128&seq=related-thumb-08&orientation=landscape',
    9: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Three%20Body%20sci-fi%20alien%20cosmic%20green%20black%20compact&width=224&height=128&seq=related-thumb-09&orientation=landscape',
    10: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Lost%20You%20Forever%20fantasy%20romance%20peach%20blossoms%20compact&width=224&height=128&seq=related-thumb-10&orientation=landscape',
    11: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20The%20Tale%20of%20Rose%20urban%20romance%20rose%20gold%20compact&width=224&height=128&seq=related-thumb-11&orientation=landscape',
    12: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Guardians%20Dafeng%20fantasy%20comedy%20dynamic%20action%20compact&width=224&height=128&seq=related-thumb-12&orientation=landscape',
    13: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Keep%20Running%20variety%20show%20outdoors%20sunny%20compact&width=224&height=128&seq=related-thumb-13&orientation=landscape',
    14: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Singer%202026%20music%20show%20stage%20spotlights%20compact&width=224&height=128&seq=related-thumb-14&orientation=landscape',
    15: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Back%20to%20Field%20slow%20living%20seaside%20cozy%20compact&width=224&height=128&seq=related-thumb-15&orientation=landscape',
    16: 'https://readdy.ai/api/search-image?query=Small%20thumbnail%20poster%20for%20Super%20Sketch%20Show%20comedy%20theater%20stage%20compact&width=224&height=128&seq=related-thumb-16&orientation=landscape',
  };

  if (!video) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
              <i className="ri-movie-line text-3xl text-foreground-300"></i>
            </div>
            <h1 className="text-xl font-bold text-foreground-900 mb-2">视频不存在</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 text-sm">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const posterSrc = posterUrls[video.id] || posterUrls[1];

  const movieSchema = {
    '@context': 'https://schema.org',
    '@type': 'Movie',
    name: video.title,
    description: video.description,
    image: posterSrc,
    dateCreated: `${video.year}`,
    director: {
      '@type': 'Person',
      name: video.director,
    },
    actor: video.actors.map((a) => ({
      '@type': 'Person',
      name: a,
    })),
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: video.rating.toString(),
      bestRating: '10',
      ratingCount: video.views,
    },
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-20 pb-12">
        <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
          <div className="mb-4">
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: video.categoryLabel, to: `/category/${video.category}` },
                { label: video.title },
              ]}
            />
          </div>

          <script type="application/ld+json">{JSON.stringify(movieSchema)}</script>

          <article className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
            <div className="lg:col-span-2">
              <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-black mb-6">
                <img
                  src={posterSrc}
                  alt={video.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-primary-500/90 hover:bg-primary-500 transition-all cursor-pointer group">
                  <i className="ri-play-fill text-white text-3xl md:text-4xl ml-1"></i>
                </div>
              </div>

              <header>
                <h1 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-3">
                  {video.title}
                </h1>
                <div className="flex items-center gap-3 flex-wrap mb-4">
                  <span className="flex items-center gap-1 text-accent-500 text-sm font-medium">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill"></i>
                    </span>
                    {video.rating} 分
                  </span>
                  <span className="text-foreground-400 text-sm">{video.year}</span>
                  <span className="text-foreground-400 text-sm">{video.duration}</span>
                  <span className="px-2 py-0.5 rounded text-xs bg-background-100 text-foreground-500 whitespace-nowrap">
                    {video.categoryLabel}
                  </span>
                  <span className="text-foreground-400 text-sm whitespace-nowrap">
                    <span className="w-4 h-4 inline-flex items-center justify-center mr-0.5">
                      <i className="ri-eye-line"></i>
                    </span>
                    {video.views.toLocaleString()} 次播放
                  </span>
                </div>

                <div className="flex flex-wrap gap-1.5 mb-6">
                  {video.tags.map((tag) => (
                    <span key={tag} className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
              </header>

              <section className="mb-6">
                <h2 className="text-lg font-bold font-heading text-foreground-900 mb-3">剧情简介</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">{video.description}</p>
              </section>

              <section className="p-4 rounded-lg bg-background-100">
                <h2 className="text-lg font-bold font-heading text-foreground-900 mb-3">影片信息</h2>
                <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="flex gap-2">
                    <dt className="text-sm text-foreground-400 whitespace-nowrap font-medium">导演：</dt>
                    <dd className="text-sm text-foreground-700">{video.director}</dd>
                  </div>
                  <div className="flex gap-2">
                    <dt className="text-sm text-foreground-400 whitespace-nowrap font-medium">主演：</dt>
                    <dd className="text-sm text-foreground-700">{video.actors.join(' / ')}</dd>
                  </div>
                  <div className="flex gap-2">
                    <dt className="text-sm text-foreground-400 whitespace-nowrap font-medium">年份：</dt>
                    <dd className="text-sm text-foreground-700">{video.year}</dd>
                  </div>
                  <div className="flex gap-2">
                    <dt className="text-sm text-foreground-400 whitespace-nowrap font-medium">类型：</dt>
                    <dd className="text-sm text-foreground-700">{video.tags.join(' / ')}</dd>
                  </div>
                  <div className="flex gap-2">
                    <dt className="text-sm text-foreground-400 whitespace-nowrap font-medium">片长：</dt>
                    <dd className="text-sm text-foreground-700">{video.duration}</dd>
                  </div>
                  <div className="flex gap-2">
                    <dt className="text-sm text-foreground-400 whitespace-nowrap font-medium">更新：</dt>
                    <dd className="text-sm text-foreground-700">{video.updateInfo}</dd>
                  </div>
                </dl>
              </section>
            </div>

            <aside>
              {video.episodes && (
                <div className="mb-6 p-4 rounded-lg bg-white border border-background-200">
                  <h3 className="font-bold font-heading text-foreground-900 mb-3 text-sm">剧集列表</h3>
                  <p className="text-sm text-accent-500 font-medium">{video.episodes}</p>
                </div>
              )}

              <div className="p-4 rounded-lg bg-white border border-background-200">
                <h3 className="font-bold font-heading text-foreground-900 mb-3 text-sm">相关推荐</h3>
                <div className="space-y-3">
                  {relatedVideos.map((rv) => (
                    <Link
                      key={rv.id}
                      to={`/article/${rv.id}`}
                      className="flex gap-3 group"
                    >
                      <div className="w-28 h-16 rounded-md overflow-hidden flex-shrink-0 bg-background-100">
                        <img
                          src={relatedImageUrls[rv.id] || relatedImageUrls[1]}
                          alt={rv.title}
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm font-medium text-foreground-800 line-clamp-2 group-hover:text-primary-600 transition-colors">
                          {rv.title}
                        </h4>
                        <div className="flex items-center gap-2 mt-1">
                          <span className="text-xs text-accent-500">
                            <span className="w-3 h-3 inline-flex items-center justify-center mr-0.5">
                              <i className="ri-star-fill text-[10px]"></i>
                            </span>
                            {rv.rating}
                          </span>
                          <span className="text-xs text-foreground-400">{rv.categoryLabel}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </aside>
          </article>
        </div>
      </main>
      <Footer />
    </>
  );
}